import { Component, OnInit , EventEmitter, Input, Output, SimpleChanges } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule, FormArray  } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../../services/user.service';
import { CommonDataService } from '../../../../services/common-data.service';
import { environment } from '../../../../../environments/environment';


declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-product-image-gallery',
  templateUrl: './product-image-gallery.component.html',
  styleUrls: ['./product-image-gallery.component.scss']
})
export class ProductImageGalleryComponent implements OnInit {

  modelForm: FormGroup;
  pageName = "Product Images";
  modelName = "Product";

  @Input() dataModel;
  @Input() dataModelId;
  @Output() formSubmitted = new EventEmitter<any>();

  localModelDataStorage = false;
  modelId = '0';
  modelData: any;
  returnData: any;
  files: any;

  filesToUpload: Array<File> = [];
  sizes: FormArray;
  previewImages = []

  btnText = 'Add New Image'
  details;

  constructor(
    //private userService: UserService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) {}

  ngOnInit() {

    this.modelData = this.dataModel;
    this.modelId = this.dataModelId;

    $('#initialise-page').trigger('click');
    $('#owl-initialise').trigger('click');

    this.prepopulate()

  }

  get f() { return this.modelForm.controls; }

  prepopulate(){
    this.previewImages = []
      if(this.modelData['files']['uploads'] && Array.isArray(this.modelData['files']['uploads']) && this.modelData['files']['uploads'].length > 0) {
        let productImages = this.modelData['files']['uploads']

        for (let index = 0; index < productImages.length; index++) {
          let element = productImages[index];

          if(element['tmp_name'] && element['tmp_name'] != '') {
            let srcStrings = element['tmp_name'].split("public/");
            let src = environment.filesSrc+'/'+srcStrings[1]
            element['src'] = src
            this.previewImages.push(element)
          }
          
        }

      }
  }


  onFileChanged(event) {
    //this.files = event.target.files[0];
    //this.modelForm.get('images').setValue(this.files);

    this.filesToUpload = <Array<File>>event.target.files;
    this.onSubmit()
  }

  onSubmit() {

    //alert('working magic!')
    this.btnText = 'Please Wait...'
    $('#loader').show();

    // if (this.modelForm.invalid) {
    //   console.log('errors are detected');
    //   this.btnText = 'Add New Image'
    //   $('#loader').hide();

    //   return;
    // }

    this.createProduct(); // run combine function
  }

  createProduct() {

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    modelObject1.append('id', this.modelId);
    const files: Array<File> = this.filesToUpload;
    console.log(files);

    for(let i =0; i < files.length; i++){
        modelObject1.append("uploads[]", files[i]);
    }


    this.updateModel(modelObject1);

  }

  updateModel (modelObject: any) {
    // Initiate new model creation/update method

    this._data.updateModelData(modelObject) 
      .pipe(first())
      .subscribe(
        data => {
 
          this.returnData = data;

          this.modelId = data['result']['id'];
          this.modelData = data['result']['model']['modelData']['formFieldsEntities'];
          console.log('this is the new model return object: '+JSON.stringify(this.returnData));

        },
        error => {
          console.log(error);
          this.btnText = 'Add New Image'
          $('#loader').hide();

          iziToast.success({
            title: 'Error!',
            position: 'topRight',
            icon: 'icon-circle-check',
            message: 'Error uploading new image.'
        });

        },

        () => {

          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your image uploaded successfuly.'
          });

          this.prepopulate()
          this.btnText = 'Add New Image'
          $('#loader').hide();

          //this.router.navigate(['/sellers/account/product-settings/?id='+id]);
          this.details = {
            step : "image",
            completed : true,
            next: "settings",
            dataModel: this.modelData,
            modelId: this.modelId
          }
          //this.formSubmitted.emit(details);
            
        }
      );
  }

  viewGallery()
  {
  	this.router.navigate(['/sellers/account/product-gallery']);
  }

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed

    // if (changes['dataModel']) {
    //   this.modelData = changes['dataModel'].currentValue;
    //   this.prepopulate();
    // }
   
  }

  next() {
    if(this.details && this.previewImages.length > 0) {
      this.formSubmitted.emit(this.details);

    }

    else {
      iziToast.success({
        title: 'Error!',
        position: 'topRight',
        icon: 'icon-circle-check',
        message: 'Please upload atleast 1 image.'
    });
    }


  }


}
